import LogoHR from '@CS/assets/logo-hr.png';
import LogoEN from '@CS/assets/logo-en.png';

export default {
  hr: LogoHR,
  en: LogoEN
};
